export enum NotificationScope {
  ALL = -1,
  GLOBAL,
  COMPANY,
  REPORT,
  REQUEST,
  BULKCUSTOM
}
